import React, { Component } from 'react';
import PatientBoxList from '../Components/Patient/PatientBoxList.js';
import TuckyDataManager from '../Components/Tucky/TuckyDataManager.js';
import PulseOximeterManager from '../Components/PulseOximeter/pulseOximeterManager.js';
import TensionManager from '../Components/Tensiometer/TensiometerManager.js'
import PainManager from '../Components/Pain/PainManager.js';
import SharesGetter from '../Controller/getShares.js';
import CreationRequestsGetter from '../Controller/getSQLCreationRequestsFunctions';
import AddPatient from '../Components/Patient/AddPatient.js';
import DefaultPatient from '../Components/Patient/PatientDefaultParams.js';
import ExportFile from '../Components/DataExport/ExportFile.js';
import PatientFunctionsGetter from "../Controller/getSQLPatientFunctions.js";

import Account from '../Popup/Account.js';
import Research from '../Popup/Research.js';
import ReceivedInvitationsMenu from '../Popup/ReceivedInvitationsMenu.js';
import SentInvitationsMenu from '../Popup/SentInvitationsMenu.js';
import Sensors from '../Popup/Sensors.js';
import About from '../Popup/About.js';
import StaffManagementMenu from '../Popup/StaffManagementMenu.js';
import StructureManagementMenu from '../Popup/StructureManagementMenu.js';
import SubscriptionManagementMenu from '../Popup/SubscriptionManagementMenu.js';
import CertificateInfoPopup from '../Popup/CertificateInfoPopup.js';
import FixturesMenu from '../Popup/FixturesMenu.js';
import GatewayManagementMenu from '../Popup/GatewayManagementMenu.js';
import GroupManagementMenu from '../Popup/GroupManagementMenu.js'; 
import WifiProvisioningMenu from '../Popup/WifiProvisioningMenu.js';

import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem, Row, Col, Card } from 'reactstrap';
import { Icon, Flag } from 'semantic-ui-react';
import './Home-style.css';
import cookie from 'react-cookies';
import axios from "axios";
import rateLimit from 'axios-rate-limit';
import { Helmet } from 'react-helmet';
import DatePeriod from '../Components/DateRange/DatePeriod.js';
import {isMobile} from 'react-device-detect';
import { Tooltip } from 'react-tooltip'

import {FormattedMessage, injectIntl} from 'react-intl';
import UserFunctionsGetter from '../Controller/getSQLUserFunctions.js';
import GroupsFunctionsGetter from '../Controller/getSQLGroupsFunctions.js';
import DeviceFunctionsGetter from '../Controller/getSQLDeviceFunctions.js';
import GatewayFunctionsGetter from '../Controller/getSQLGatewayFunctions.js';

import logo_tucky_computer from '../Images/Logo/logo_tucky_computer.png';
import logo_tucky_smartphone from '../Images/Logo/logo_tucky_smartphone.png';

import keycloak from '../Keycloak'

import * as XLSX from 'xlsx/xlsx.mjs';
import * as ExcelJS from 'exceljs';
import * as FileSaver from 'file-saver';
import bwipjs from "bwip-js";
import { Buffer } from 'buffer';


import { AiOutlineUnorderedList, AiTwotoneSetting } from 'react-icons/ai';
import { GoGraph } from 'react-icons/go';

import Utils from "../Components/Common/Utils.js";
import jwt_decode from "jwt-decode";

class Home extends Component {
    constructor(props) {

        window.interval = null;

        super(props);

        this.accountInformation = [];           // Contains information about account
        this.structure_info = {'struct_name':'unknown', 'subscription':'unknown'} ;
        this.subscription_info = {'id_subscription':'unknown', 'sub_used':'unknown', 'sub_total':'unknown', 'expiration_date':'unknown'} ;

        let initCurrentDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0, 0);
        let actualDateStart = new Date(initCurrentDate.getFullYear(), initCurrentDate.getMonth(), initCurrentDate.getDate()-1, 0, 0, 0, 0).toISOString();
        let actualDateEnd = new Date(initCurrentDate.getFullYear(), initCurrentDate.getMonth(), initCurrentDate.getDate(), 23, 59, 59, 999).toISOString();
        const {intl} = props;

        this.data = [];
        this.headers = [
            { label: "Profile fullname", key: "fullName" },
            { label: "Temperature date", key: "temperatureDate" },
            { label: "Temperature", key: "temperature" },
            { label: "SPO2 and Pulse Rate date", key: "spo2PrDate" },
            { label: "SPO2", key: "spo2" },
            { label: "Pulse Rate", key: "pulseRate"},
            { label: "Tensiometer Tension and Pulse Rate date", key: "tensiometerDate" },
            { label: "Tensiometer Tension", key: "tensiometerTension" },
            { label: "Tensiometer Pulse Rate", key: "tensiometerPulseRate"}
        ];

        this.languages = [
          { name: "English", code: "en-GB", flag: "🇬🇧" },
          { name: "Français", code: "fr-FR", flag: "🇫🇷" },
          { name: "Español", code: "es-ES", flag: "🇪🇸" },
        ];

        this.state = {
            profilesInformation: [],        // Contains all information about the profiles of the account (serial number, firstname, lastname, birthdate, enablePositionAlert, feverAlertTemperature, gender, picture, size, weight)*/
                                            // + table of all profile data (serialnumber, temperature, PrSp02...)
            popup: "",                      /* Determines popup to be displayed or not */
            popupParams: {},                    /* Extra params passed to the current popup */
            noStructureError: false,        /* Staff/admin user not linked to a valid structure */
            dropdownOpen: false,            /* Determines the state of the dropdown menu button */
            adminDropdownOpen: false,       /* Determines the state of the admin dropdown menu button */
            hidePatientIds: localStorage.getItem('hidePatientIds') === 'true', /* Hide id_patient display for admin_etc users */
            hideAdminMenu: localStorage.getItem('hideAdminMenu') === 'true', /* Hide the admin dropdown menu for admin_etc users */
            languagesDropdownOpen: false,   /* Determines the state of the languages dropdown menu button */
            groupsDropdownOpen: false,     /* Determines the state of the languages dropdown menu button */
            switchExtendedView: "list",     /* Determines extended view display */
            loadingState: false,
            fileToDownload: [],
            filename: "Tucky_Center_Export.csv",
            structure_groups: [],
            structure_devices: [],
            previous_filter: '{"id":"null", "type":"group"}',
            dateSelected: [actualDateStart, actualDateEnd],
            staff_list: [],
            all_users_list: [],
            template_list: [],
            pendingInvitesCount: 0
        };

        this.handleAccount                 = this.handleAccount.bind(this);
        this.handleResearch                = this.handleResearch.bind(this);
        this.handleReceivedInvitationsMenu = this.handleReceivedInvitationsMenu.bind(this);
        this.handleSentInvitationsMenu     = this.handleSentInvitationsMenu.bind(this);
        this.handleSensors                 = this.handleSensors.bind(this);
        this.handleGateways                = this.handleGateways.bind(this);
        this.handleAbout                   = this.handleAbout.bind(this);
        this.handleAddPatient              = this.handleAddPatient.bind(this);
        this.handleFileToDownload          = this.handleFileToDownload.bind(this);
        this.handleDownloadExport          = this.handleDownloadExport.bind(this);
        this.handleSelectedDate            = this.handleSelectedDate.bind(this);
        this.handleGroups                  = this.handleGroups.bind(this);
        this.handleFilterChange            = this.handleFilterChange.bind(this);
        this.cancelPopup                   = this.cancelPopup.bind(this);
        this.closeAfterAddingNewPatient    = this.closeAfterAddingNewPatient.bind(this);
        this.disconnect                    = this.disconnect.bind(this);
        this.updateProfileParameters       = this.updateProfileParameters.bind(this);
        this.handleStaffManagementMenu     = this.handleStaffManagementMenu.bind(this);
        this.handleStructureManagementMenu = this.handleStructureManagementMenu.bind(this);
        this.handleSubscriptionManagementMenu = this.handleSubscriptionManagementMenu.bind(this);
        this.handleOpenStructuresForSubscription = this.handleOpenStructuresForSubscription.bind(this);
        this.handleOpenSubscriptionFromStructure = this.handleOpenSubscriptionFromStructure.bind(this);
        this.handleCertificateMenu = this.handleCertificateMenu.bind(this);
        this.handleFixturesMenu = this.handleFixturesMenu.bind(this);
        this.resetFilter                   = this.resetFilter.bind(this);
        this.handleWifiProvisioningMenu = this.handleWifiProvisioningMenu.bind(this);

    }

    async handleViewChange(e) {
        this.props.handleViewChange(e)
    };

    async handleFilterChange(e) {

        // launch INS search popup
        if (e.target.value === '{"id":"INS_search", "type":"patient"}') {
            await this.setState(state => ({
                previous_filter: this.props.currentFilter,
                popup: "research"                
            }))
        }
        else {
            // Case all patients
            if (e.target.value === '{"id":"null", "type":"group"}') {
                await this.setState(state => ({
                    previous_filter: this.props.currentFilter,
                }))
            }
            // Case patient or group selection
            else {
                await this.setState(state => ({
                    previous_filter: this.props.currentFilter,
                }))
            }
            this.props.handleFilterChange(e)
                this.reloadUserAndProfiles()
            }
    };

	async componentDidMount(){
        await this.load_view();
        await this.reloadUserAndProfiles();
        this.set_request_pulling();        
    }

    /// LOGOUT FUNCTION ///
    disconnect = async () => {
        keycloak.logout();
    }

    reloadUserAndProfiles = async () => {
        const accountOk = await this.load_user_account();
        if (accountOk === false) return;
        await this.load_groups();
        await this.load_devices();
        //add gateway and devices; common function with group?
        await this.load_profiles();
        await this.load_staff();
        await this.load_pending_invites_count();
        if (process.env.NODE_ENV === 'debug'){
            console.log( "Account information:");
            console.log(this.accountInformation)
        }        
    }

    //// POPUP FUNCTIONS ////
    cancelPopup = () => {
        this.setState({ popup: "", popupParams: {} })
    }

    handleAccount(e) {
        e.preventDefault();

        this.setState(state => ({
            popup: "account"
        }));
    }

    handleResearch(e) {
        e.preventDefault();

        this.setState(state => ({
            popup: "research"
        }));
    }

    handleReceivedInvitationsMenu(e) {
        e.preventDefault();

        this.setState(state => ({
            popup: "receivedInvitations",
            pendingInvitesCount: 0
        }));
    }

    handleSentInvitationsMenu(e){
        e.preventDefault();

        this.setState({
            popup: "sentInvitations"
        })
    }

    handleSensors(e) {
        e.preventDefault();

        this.setState(state => ({
            popup: "sensors"
        }));
    }

    handleGateways(e) {
        e.preventDefault();

        this.setState(state => ({
            popup: "gateways"
        }));
    }

    handleWifiProvisioningMenu(e) {
        e.preventDefault();

        this.setState(state => ({
            popup: "wifiProvisioning"
        }));
    }

    handleGroups(e) {
        e.preventDefault();

        this.setState(state => ({
            popup: "groups"
        }));
    }

    handleAbout(e) {
        e.preventDefault();

        this.setState(state => ({
            popup: "about"
        }));
    }

    handleStaffManagementMenu(e){
        e.preventDefault();

        this.setState(state => ({
            popup: "staff"
        }));
    }

    handleStructureManagementMenu(e){
        e.preventDefault();

        this.setState(state => ({
            popup: "structure",
            popupParams: {}
        }));
    }

    handleSubscriptionManagementMenu(e){
        e.preventDefault();

        this.setState(state => ({
            popup: "subscription",
            popupParams: {}
        }));
    }

    handleOpenStructuresForSubscription(subscriptionId) {
        this.setState({ popup: "structure", popupParams: { subscriptionFilter: subscriptionId } });
    }

    handleOpenSubscriptionFromStructure(subscriptionId) {
        this.setState({ popup: "subscription", popupParams: { highlightId: subscriptionId } });
    }

    handleCertificateMenu(e){
        e.preventDefault();

        this.setState(state => ({
            popup: "certificate"
        }));
    }

    handleFixturesMenu(e){
        e.preventDefault();

        this.setState(state => ({
            popup: "fixturesMenu"
        }));
    }

    handleAddPatient = async (e) => {
        e.preventDefault();
        let profile_infos = [];
        let template_group = this.state.structure_groups.find(group => { return group.group_name === "Templates"})

        if (template_group !== undefined) {
            let local_Objects = await PatientFunctionsGetter.get_Patients("group", template_group.id_group);
            if((local_Objects !== undefined)&&(local_Objects.length !== undefined)&&(local_Objects.length !== 0)){
                for(const object of local_Objects) {
                    // Get patient information
                    let local_Data = PatientFunctionsGetter.convert_patient_input_data(object, this.state.profilesInformation, this.state.structure_devices, this.accountInformation);
                    profile_infos.push({
                        'Patient_Data': local_Data
                    });
                }
            }
        }

        this.setState(state => ({
            template_list: profile_infos,
            popup: "addpatient"
        }));
    }

    handleViewChangeButton(id){

        if(id === 1){
            this.handleViewChange({target:{value:'1'}})
            this.setState(state => ({
                switchExtendedView: "graph"
            }));
        }
        if(id === 2){
            this.handleViewChange({target:{value:'2'}})
            this.setState({
                switchExtendedView: "parameters"
            });
        }
        if(id === 3){
            this.handleViewChange({target:{value:'3'}})
            this.setState({
                switchExtendedView: "list"
            });
        }
    }

    renderChangeViewButton(id){
        if(id === this.state.switchExtendedView){
            return ("#30677F")
        }
        else {
            return ("white")
        }
    }

    handleSearchPatient(e){
        e.preventDefault();

        this.setState(state => ({
            popup: "research"
        }));
    }


    closeAfterAddingNewPatient(){
        this.cancelPopup();
        this.reloadUserAndProfiles();
    };

    setDeviceList = (new_list) => {
        this.setState({
            structure_devices: new_list
        });
    };

    setGatewayList = (new_list) => {
        this.setState({
            structure_gateways: new_list
        });
    };

    //// MENU FUNCTIONS ////
    toggle = () => {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    }

    languageToggle = () => {
        this.setState({
            languagesDropdownOpen: !this.state.languagesDropdownOpen
        });
    }

    groupsToggle = () => {
        this.setState({
            groupsDropdownOpen: !this.state.groupsDropdownOpen
        });
    }

    adminToggle = () => {
        this.setState({
            adminDropdownOpen: !this.state.adminDropdownOpen
        });
    }

    toggleHidePatientIds = () => {
        const newVal = !this.state.hidePatientIds;
        localStorage.setItem('hidePatientIds', newVal);
        this.setState({ hidePatientIds: newVal });
    }

    toggleHideAdminMenu = () => {
        const newVal = !this.state.hideAdminMenu;
        localStorage.setItem('hideAdminMenu', newVal);
        this.setState({ hideAdminMenu: newVal });
    }

    //// DATERANGEPICKER FUNCTIONS ////
    handleSelectedDate = (dateTab) => {

        let dates = [];

        dateTab.forEach(date => {
            let convertedDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()).toISOString();
            dates.push(convertedDate);
        })

        this.setState({ dateSelected: dates });
    }

    //// EXPORT FUNCTIONS ////
    handleFileToDownload(updatedFile){
        this.setState({fileToDownload: updatedFile});
    }

    async handleDownloadExport(e){
        let patient_data = [];
        let local_filename = "";        

        e.preventDefault();

        // Get document filename
        local_filename = await ExportFile.getExportFileName(this.state.dateSelected);

        const workbook = new ExcelJS.Workbook();
        let i = 0;
        while (this.state.profilesInformation[i]) {
            let sheet = ExportFile.generateWorksheet(workbook, this.state.profilesInformation[i], this.props.intl, this.subscription_info.features);
            i++;
        }
        await workbook.xlsx.writeBuffer(local_filename).then(data => {
            const blob = new Blob([data], { type: this.blobType });
            FileSaver.saveAs(blob, local_filename);
        });

    }


    /*Function to retrieve user acount  */
    load_user_account = async () => {

        let token = cookie.load('token')

        var decoded_token = jwt_decode(token);
        let practitioner_id = decoded_token.preferred_username
        practitioner_id = practitioner_id.replace('/', '%2F') //replacing slash with usable http character
        let all_users_list = await UserFunctionsGetter.get_User_Account()
        let full_user_data = await UserFunctionsGetter.convert_fhir_user_admin(all_users_list)
        this.accountInformation = Utils.fhir_convert_user_data(full_user_data)
        this.props.handleLocaleChange(this.accountInformation.username, {target:{value:this.accountInformation.language}})

        if((this.accountInformation !== undefined)&&(this.accountInformation.length !== 0)) {
            const hasStructure = this.accountInformation.FK_structure
                && this.accountInformation.FK_structure !== 'none'
                && this.accountInformation.FK_structure !== 'null'
                && this.accountInformation.FK_structure !== null;

            if (hasStructure) {
                this.structure_info = Utils.fhir_get_structure_data(full_user_data);
                if (this.structure_info !== undefined && this.structure_info.struct_name) {
                    this.subscription_info = Utils.fhir_get_subscription_data(full_user_data); // FHIR VERSION
                    console.log("User " + this.accountInformation.email + " is logged as " + this.accountInformation.role + " of structure " + this.structure_info.struct_name);
                } else {
                    // Structure reference exists but is incomplete/missing
                    if (this.accountInformation.role === 'admin' || this.accountInformation.role === 'staff') {
                        console.warn("User " + this.accountInformation.email + " is staff/admin but structure is missing or incomplete");
                        await this.setState({ all_users_list: all_users_list, noStructureError: true });
                        return false;
                    }
                }
            }
            else {
                if (this.accountInformation.role === 'admin' || this.accountInformation.role === 'staff') {
                    console.warn("User " + this.accountInformation.email + " is staff/admin but not linked to any structure");
                    await this.setState({ all_users_list: all_users_list, noStructureError: true });
                    return false;
                }
                console.log("Structure not defined");
                // Registered users have no structure, but keep their loaded account data
                // (email, username, id_user...) instead of replacing it with a stub —
                // otherwise accountInformation.email is lost and features like the received
                // invitations list (which queries by email) break.
                this.accountInformation.structure = 'none';
                if (this.accountInformation.role === undefined || this.accountInformation.role === null || this.accountInformation.role === '') {
                    this.accountInformation.role = 'registered';
                }
            }
        }
        await this.setState({
            all_users_list: all_users_list,
        });
        return true;

    }

    //// GROUP FUNCTIONS ////
    load_groups = async () => {

        let local_structure_groups = [];
        let local_retrieved_groups = await GroupsFunctionsGetter.get_Structure_Groups();
        
        if (Array.isArray(local_retrieved_groups) && local_retrieved_groups.length > 0) {
            local_retrieved_groups.unshift({id_group: 'nogroup', group_name: this.props.intl.formatMessage({id: "param.nogroup"}), description: ''})
            local_retrieved_groups.unshift({id_group: 'monitored', group_name: this.props.intl.formatMessage({id: "param.groupmonitored"}), description: ''})
            local_retrieved_groups.forEach(group => {
                local_structure_groups.push(group);
            })
        }
        await this.setState({
            structure_groups: local_structure_groups,
        })
    }

    //// DEVICE FUNCTIONS ////
    load_devices = async () => {

        let local_retrieved_devices_and_gateway = [];
        let local_retrieved_devices = [];
        let local_structure_devices = [];
        let local_retrieved_gateways = [];
        let local_structure_gateways = [];
        if (this.accountInformation.role === "admin" || this.accountInformation.role === "staff") {
            local_retrieved_devices_and_gateway = await DeviceFunctionsGetter.get_device_list(this.accountInformation.FK_structure);
            local_retrieved_devices = DeviceFunctionsGetter.convert_fhir_devices(local_retrieved_devices_and_gateway)
            local_retrieved_gateways = GatewayFunctionsGetter.convert_fhir_gateway(local_retrieved_devices_and_gateway);

            if((local_retrieved_devices !== "none")&&(local_retrieved_devices !== undefined)&&(local_retrieved_devices.length !== 0)){
                local_retrieved_devices.forEach(group => {
                    local_structure_devices.push(group);
                })
            }
            if((local_retrieved_gateways !== "none")&&(local_retrieved_gateways !== undefined)&&(local_retrieved_gateways.length !== 0)){
                local_retrieved_gateways.forEach(group => {
                    local_structure_gateways.push(group);
                })
            }
        }
        await this.setState({
            structure_devices: local_structure_devices,
            structure_gateways: local_structure_gateways,
        })
    }

    //// VIEW FUNCTIONS ////
    load_view = async () => {
        if(this.props.currentView === "1"){
            this.setState(state => ({
                switchExtendedView: "graph"
            }));
        }
        if(this.props.currentView === "2"){
            this.setState({
                switchExtendedView: "parameters"
            });
        }
        if(this.props.currentView === "3"){
            this.setState({
                switchExtendedView: "list"
            });
        }
    }


    //// PROFILES FUNCTIONS ////
    /*Function to load profiles by:
    1- Retrieving patients from filter
    2- Retrieving profile information 
    */
    load_profiles = async () => {

        let profile_infos = [];
        let local_Objects = [];
        let local_template_list = [];

        // Update filter select display
        let filter_select = document.getElementById("group_selector")
        if(filter_select !== null){
        filter_select.value = this.props.currentFilter
        }

        // load patient or group
        let decoded_filter = JSON.parse(this.props.currentFilter);
    	local_Objects = await PatientFunctionsGetter.get_Patients(decoded_filter.type, decoded_filter.id);

        if((local_Objects !== undefined)&&(local_Objects.length !== undefined)&&(local_Objects.length !== 0)){
            let template_group_id = null
            let template_group_index = this.state.structure_groups.findIndex((g) => g.group_name === "Templates")
            if (template_group_index !== -1) {
                template_group_id = this.state.structure_groups[template_group_index].id_group
            }
            for(const object of local_Objects) {

                // Flag mal-created patients instead of crashing
                if (object._invalid === true) {
                    profile_infos.push({
                        Patient_Data: { _invalid: true, id_patient: object.identifier }
                    });
                    continue;
                }

                // Get patient information
                let local_Data = PatientFunctionsGetter.convert_patient_input_data(object, this.state.profilesInformation, this.state.structure_devices, this.accountInformation);

                    profile_infos.push({
                        'Patient_Data': local_Data
                    });
                if (local_Data.group === template_group_id) {
                    local_template_list.push({
                        'Patient_Data': local_Data
                    })
                }
            }
            await this.setState({
            })
        }

        await this.setState({
            profilesInformation: profile_infos,
            template_list: local_template_list,
            // Display once all profiles are loaded
            loadingState: true,

        })

    }

    /*Function to retrieve staff if user is admin  */
    load_staff = async () => {

        if (this.accountInformation.role === "admin") {
            let local_user_List = [];
            local_user_List = UserFunctionsGetter.convert_fhir_user_staff(this.state.all_users_list);
            if(local_user_List !== undefined){
                await this.setState({
                    staff_list: local_user_List
                });
            }
        }
    }

    /*Function to update patient's profile parameters*/
    updateProfileParameters = async (updated_data) => {

        let local_Profile_Information = this.state.profilesInformation;
        if((local_Profile_Information !== undefined)&&(local_Profile_Information.length !== 0)&&(updated_data !== undefined)){
            local_Profile_Information.forEach(profile_info => {
                if(profile_info.Patient_Data.id_patient === updated_data.Patient_Data.id_patient){
                    profile_info = updated_data;                    
                    if (typeof(this.state.dateSelected[0]) === "string") {
                        this.state.dateSelected[0] = new Date(this.state.dateSelected[0]);
                    }
                    if (typeof(this.state.dateSelected[1]) === "string") {
                        this.state.dateSelected[1] = new Date(this.state.dateSelected[1]);
                    }
                    // Set MaxFeverDrawing
                    profile_info.Patient_Data.MaxFeverDrawing = Utils.setAlertCurve(this.state.dateSelected[0], this.state.dateSelected[1], updated_data.Patient_Data.alerts.fever_alert.threshold);
                    // Set Pulse Rate alert curve
                    profile_info.Patient_Data.MaxPulseRateDrawing = Utils.setAlertCurve(this.state.dateSelected[0], this.state.dateSelected[1], updated_data.Patient_Data.alerts.PR_alert.threshold);
                    // Set SpO2 alert curve
                    profile_info.Patient_Data.MinSpO2Drawing = Utils.setAlertCurve(this.state.dateSelected[0], this.state.dateSelected[1], updated_data.Patient_Data.alerts.SPO2_alert.threshold);
                    // Set tensiometer Pulse Rate alert curve
                    profile_info.Patient_Data.MaxPulseRateDrawingTension = Utils.setAlertCurve(this.state.dateSelected[0], this.state.dateSelected[1], updated_data.Patient_Data.alerts.bloodpressure_PR_alert.threshold);
                    // Set bloodpressure systolic alert curve
                    profile_info.Patient_Data.MaxSystolicDrawingTension = Utils.setAlertCurve(this.state.dateSelected[0], this.state.dateSelected[1], updated_data.Patient_Data.alerts.bloodpressure_sys_high_alert.threshold);
                    // Set bloodpressure diastolic alert curve
                    profile_info.Patient_Data.MaxDiastolicDrawingTension = Utils.setAlertCurve(this.state.dateSelected[0], this.state.dateSelected[1], updated_data.Patient_Data.alerts.bloodpressure_dia_alert.threshold);
                    // Set scale alert curve
                    profile_info.Patient_Data.weightThreshold = Utils.setAlertCurve(this.state.dateSelected[0], this.state.dateSelected[1], updated_data.Patient_Data.alerts.weight_alert.threshold);
                      
                    // TMP : pain and healthform to add
                }   

            })
                this.setState({
                    profilesInformation: local_Profile_Information
                }) 
        }

        local_Profile_Information = null;
    }
    

    //Function to reset the filter
    resetFilter() {
        let filter_select = document.getElementById("group_selector")
        filter_select.value = '{"id":"null", "type":"group"}'
        this.handleFilterChange({target:{value:'{"id":"null", "type":"group"}'}})
    }

    // Function to fill the tooltip with different languages
    select_tooltip(type) {
        let def = "";
        switch (type) {
            case "home.banner-graph":
                def = "Banner & Graph";
                break;
            case "home.banner-param":
                def = "Banner & Parameters";
                break;
            case "home.tooltip.addpatient":
                def = "Add a patient";
                break;
            case "home.tooltip.menu":
                def = "Main menu";
                break;
            case "param.reminderMode":
                def = "Reminder";
                break;
            case "param.reminderMode.tooltip":
                def = "Reminder";
                break;
        }
        let ret = <FormattedMessage id={type} defaultMessage={def}/>
        return (ret)
    }

    //// REQUESTS FUNCTIONS ////
    set_request_pulling = () => {

        if((window.interval === null)||(window.interval === undefined)){

            window.interval = setInterval(async () => {
                await this.reloadUserAndProfiles();
            },120000)
        }
    }

    load_pending_invites_count = async () => {
        if (!this.accountInformation.email) return;
        try {
            const requests = await CreationRequestsGetter.get_requests_received_list(this.accountInformation.email);
            // Badge counts only invitations still to handle: accepted/refused traces don't count.
            const pending = Array.isArray(requests) ? requests.filter(r => !r.status || r.status === 'pending') : [];
            this.setState({ pendingInvitesCount: pending.length });
        } catch (e) {
            // silent — badge stays at last known value
        }
    }

    displayTemplateGroup = () => {
        let is_template = this.state.structure_groups.find(({group_name}) => group_name === "Templates")
        if (is_template === undefined) {
            return (null)
        }
        else {            
            return (
                <option value={'{"id":"'+is_template.id_group+'", "type":"group"}'} key={this.state.structure_groups.length + 1}>{is_template.group_name}</option>
            )
        }
    }

    displayTemplateGroupSmartphone = () => {
        let is_template = this.state.structure_groups.find(({group_name}) => group_name === "Templates")
        if (is_template === undefined) {
            return (null)
        }
        else {            
            return (
                <DropdownItem style={{ fontSize: "0.9em" }} onClick={() => this.handleFilterChange({target:{value:'{"id":"'+is_template.id_group+'", "type":"group"}'}})}>
                    {is_template.group_name}
                </DropdownItem>
            )
        }
    }

    displayMonitoredGroup = () => {
        let is_template = this.state.structure_groups.find(({id_group}) => id_group === "monitored")
        if (is_template === undefined) {
            return (null)
        }
        else {            
            return (
                <FormattedMessage id="param.groupmonitored" defaultMessage="Monitored patient">
                    {(message) => <option value={'{"id":"'+is_template.id_group+'", "type":"group"}'} key={this.state.structure_groups.length + 2}>{message}</option>}
                </FormattedMessage>
            )
        }
    }

    displayMonitoredGroupSmartphone = () => {
        let is_template = this.state.structure_groups.find(({id_group}) => id_group === "monitored")
        if (is_template === undefined) {
            return (null)
        }
        else {            
            return (
                <FormattedMessage id="param.groupmonitored" defaultMessage="Monitored patient">
                    {(message) => 
                <DropdownItem style={{ fontSize: "0.9em" }} onClick={() => this.handleFilterChange({target:{value:'{"id":"'+is_template.id_group+'", "type":"group"}'}})}>
                            {message}
                </DropdownItem>
                    }
                </FormattedMessage>
            )
        }
    }

    getCurrentLanguageMenu = () => {
        switch (this.accountInformation.language) {
            case "en-GB":
                return (<span onClick={this.languageToggle} style={{width:"100%"}}><Flag name='uk'/></span>)
                break
            case "fr-FR":
                return (<span onClick={this.languageToggle} style={{width:"100%"}}><Flag name='fr'/></span>)
                break
            case "es-ES":
                return (<span onClick={this.languageToggle} style={{width:"100%"}}><Flag name='es'/></span>)
                break
            default:
                return (null)
                break
        }
    }

    setCurrentLanguageMenu = (e) => {
        this.props.handleLocaleChange(this.accountInformation.username, {target:{value:e}})
        this.accountInformation.language = e
    }

    render() {

        const renderNavBarLogo = () => {
            return(
                (this.props.screenSize.width !== undefined && this.props.screenSize.width < 600) ?
                <Col style={{ maxWidth: "40px", minWidth: "40px", flex: "0 0 40px", paddingLeft: 4, paddingRight: 4 }}>
                    <img
                        src={logo_tucky_smartphone}
                        style={{ height: "auto", maxHeight: "40px", width: "auto", maxWidth: "40px"}}
                        alt="logo_tucky_smartphone"
                    />
                </Col>                          
                :
                <Col style={{ maxWidth: "300px"}}>
                    <img
                        src={logo_tucky_computer}
                        style={{ height: "auto", maxHeight: "100px", width: "auto", maxWidth: "100px" }}
                        alt="logo_tucky_computer"  
                    />
                </Col>                    
            )
        }

        const renderFilterViewAndDate = () => {
            return(
                <Col xs={9}>
                    <Row style={{marginTop:"auto"}}>
                        <div className="row justify-content-around custom-line">
                            {this.props.screenSize.width !== undefined && this.props.screenSize.width > 600 ?
                            <div className="col-2" style={{color:"white", display: "flex", justifyContent: "center", alignItems: "center", paddingRight:0}}>
                                <Tooltip style={{ zIndex: 99 }} id="tooltip-role">
                                    <div>{this.accountInformation.lastName || ''} {this.accountInformation.firstName || ''}</div>
                                    <div>{this.accountInformation.email || ''}</div>
                                    <div>{(this.structure_info && this.structure_info.struct_name && this.structure_info.struct_name !== 'unknown') ? `${this.structure_info.struct_name} ` : ''}({this.accountInformation.role || ''})</div>
                                </Tooltip>
                                <span data-tooltip-id="tooltip-role" data-tooltip-place="bottom" style={{cursor:"default"}}>
                                    {Utils.convertRoleToText(this.accountInformation.role, this.accountInformation.readOnly)}
                                </span>
                            </div>
                            : null}
                            <div className="col-3" style={{paddingRight:0}}>
                            {(this.accountInformation.role === "admin")||(this.accountInformation.role === "staff") ? 
                                this.props.screenSize.width !== undefined && this.props.screenSize.width > 600 ?
                                <center>
                                    <div style={{maxWidth:"auto", color:"white", fontSize:"120%", marginTop:"auto"}}>
                                        <FormattedMessage id="home.filter" defaultMessage="Filter" />
                                    </div>
                                    {!(this.props.currentFilter === '{"id":"null", "type":"group"}') ?
                                        <button onClick={this.resetFilter} style={{backgroundColor: "#3A5774", borderRadius: "5px", border:"0px", fontSize: "1.2em"}}>
                                            <Icon name='close' size='small' color='black' style={{margin:"3px"}}/>
                                        </button>
                                    :
                                        null
                                    }
                                    <select defaultValue={this.props.currentFilter} onChange={this.handleFilterChange} id="group_selector" name="group_selector" style={{maxWidth:"100%", padding: "6px 12px", borderRadius: "8px", border: "1px solid #ccc", fontSize: "0.95em", backgroundColor: "#fff", boxShadow: "0 1px 3px rgba(0,0,0,0.08)", cursor: "pointer"}}>
                                        <FormattedMessage id="list.filter.all" defaultMessage="All">
                                            {(message) => <option key={"all"} value={'{"id":"null", "type":"group"}'}>{message}</option>}
                                        </FormattedMessage>
                                        {this.displayMonitoredGroup()}
                                        {Utils.checkBit(this.subscription_info.features, Utils.featureToBitNumber("hepadom")) ?
                                            null
                                            :
                                            <FormattedMessage id="list.filter.research" defaultMessage="Research patient">
                                                {(message) => <option key={this.state.structure_groups.length} value={'{"id":"INS_search", "type":"patient"}'}>{message}</option>}
                                            </FormattedMessage>
                                        }
                                        <optgroup label={this.props.intl.formatMessage({id: "param.group"})}>
                                        {
                                            this.state.structure_groups.map((group,index)=> {
                                                if (group.group_name !== "Templates" && group.id_group !== "monitored") {
                                              return <option value={'{"id":"'+group.id_group+'", "type":"group"}'} key={index}>{group.group_name}</option>;
                                                }
                                            })
                                        }
                                        </optgroup>
                                        {this.displayTemplateGroup()}
                                    </select>
                                </center>
                                :
                                    <div style={{display:"flex"}}>
                                        <div style={{width:"50%", display:"flex", justifyContent:"center", alignItems:"center"}}>
                                        {!(this.props.currentFilter === '{"id":"null", "type":"group"}') ?
                                            <button onClick={this.resetFilter} style={{backgroundColor: "#3A5774", padding:"4px", borderRadius: "5px", border:"0px", fontSize: "1.2em", justifyContent:"center"}}>
                                                <Icon name='close' color='black' style={{margin:0}}/>
                                            </button>
                                            :
                                            null
                                        }
                                        </div>
                                        <div style={{width:"50%"}}>
                                        <ButtonDropdown id="group_selector" isOpen={this.state.groupsDropdownOpen} toggle={this.groupsToggle} style={{width:"100%", height:"100%", padding: 0}}>
                                            <DropdownToggle no-caret="true" style={{backgroundColor: "#212529", borderRadius: "5px", fontSize: "0.8em", justifyContent:"center", width:"100%", padding: 0}}>
                                                <Icon name='filter' size='big' inverted color='grey' style={{margin:0}}/>
                                            </DropdownToggle>
                                            <DropdownMenu style={{width:"100%", padding: 0}}>
                                                <DropdownItem style={{ fontSize: "0.9em" }} onClick={() => this.handleFilterChange({target:{value:'{"id":"null", "type":"group"}'}})}>
                                                    <FormattedMessage id="list.filter.all" defaultMessage="All"></FormattedMessage>
                                                </DropdownItem>
                                                {this.displayMonitoredGroupSmartphone()}
                                                {Utils.checkBit(this.subscription_info.features, Utils.featureToBitNumber("hepadom")) ?
                                                    null
                                                    :
                                                    <DropdownItem style={{ fontSize: "0.9em" }} onClick={() => this.handleFilterChange({target:{value:'{"id":"INS_search", "type":"patient"}'}})}>
                                                        <FormattedMessage id="list.filter.research" defaultMessage="Research patient" />
                                                    </DropdownItem>
                                                }
                                                {
                                                    this.state.structure_groups.map((group,index)=> {
                                                        if (group.group_name !== "Templates" && group.id_group !== "monitored") {
                                                            return (
                                                                <DropdownItem style={{ fontSize: "0.9em" }} onClick={() => this.handleFilterChange({target:{value:'{"id":"'+group.id_group+'", "type":"group"}'}})}>
                                                                    {group.group_name}
                                                                </DropdownItem>
                                                            )
                                                        }
                                                    })
                                                }
                                                {this.displayTemplateGroupSmartphone()}
                                            </DropdownMenu>
                                        </ButtonDropdown>
                                        </div>
                                    </div>
                                :
                                null
                            }
                            </div>
                            {this.props.screenSize.width !== undefined && this.props.screenSize.width > 600 ?
                                <div className="col-5" style={{display: "inline-block"}}> 
                                <center>
                                    <div style={{width:"auto", color:"white", fontSize:"120%", marginTop:"auto"}}>                            
                                        <FormattedMessage id="home.view" defaultMessage="View"/>
                                    </div>   
                                    <Tooltip style={{ zIndex: 99 }} id="tooltip-button-list">
                                            {this.select_tooltip("home.banner-list")}
                                        </Tooltip>
                                        <button onClick={() => this.handleViewChangeButton(3)} style={{backgroundColor:this.renderChangeViewButton("list"), borderRadius: "5px", border: "1px solid grey", fontSize: "1.5em", marginRight:"5%"}} data-tooltip-id="tooltip-button-list" data-tooltip-place="bottom">
                                            <AiOutlineUnorderedList/>
                                        </button>
                                    <Tooltip style={{ zIndex: 99 }} id="tooltip-button-graph">
                                        {this.select_tooltip("home.banner-graph")}
                                    </Tooltip>
                                        <button onClick={() => this.handleViewChangeButton(1)} style={{backgroundColor:this.renderChangeViewButton("graph"), borderRadius: "5px", border: "1px solid grey", fontSize: "1.5em", marginRight:"5%"}} data-tooltip-id="tooltip-button-graph" data-tooltip-place="bottom">
                                        <GoGraph/>
                                    </button>
                                    <Tooltip style={{ zIndex: 99 }} id="tooltip-button-params">
                                        {this.select_tooltip("home.banner-param")}
                                    </Tooltip>
                                        <button onClick={() => this.handleViewChangeButton(2)} style={{backgroundColor:this.renderChangeViewButton("parameters"), borderRadius: "5px", border: "1px solid grey", fontSize: "1.5em"}} data-tooltip-id="tooltip-button-params" data-tooltip-place="bottom">
                                        <AiTwotoneSetting/>
                                    </button>
                                </center>
                            </div>
                                :
                                <div className="col-5" style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                                    <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                                        <Tooltip style={{ zIndex: 99 }} id="tooltip-button-list">
                                            {this.select_tooltip("home.banner-list")}
                                        </Tooltip>
                                        <button onClick={() => this.handleViewChangeButton(3)} style={{backgroundColor:this.renderChangeViewButton("list"), borderRadius: "5px", border: "1px solid grey", fontSize: "1.2em", marginRight:"5%"}} data-tooltip-id="tooltip-button-list" data-tooltip-place="bottom">
                                            <AiOutlineUnorderedList/>
                                        </button>
                                        <Tooltip style={{ zIndex: 99 }} id="tooltip-button-graph">
                                            {this.select_tooltip("home.banner-graph")}
                                        </Tooltip>
                                        <button onClick={() => this.handleViewChangeButton(1)} style={{backgroundColor:this.renderChangeViewButton("graph"), borderRadius: "5px", border: "1px solid grey", fontSize: "1.2em", marginRight:"5%"}} data-tooltip-id="tooltip-button-graph" data-tooltip-place="bottom">
                                            <GoGraph/>
                                        </button>
                                        <Tooltip style={{ zIndex: 99 }} id="tooltip-button-params">
                                            {this.select_tooltip("home.banner-param")}
                                        </Tooltip>
                                        <button onClick={() => this.handleViewChangeButton(2)} style={{backgroundColor:this.renderChangeViewButton("parameters"), borderRadius: "5px", border: "1px solid grey", fontSize: "1.2em"}} data-tooltip-id="tooltip-button-params" data-tooltip-place="bottom">
                                            <AiTwotoneSetting/>
                                        </button>
                                    </div>
                                </div>
                            }
                            <div className="col-2" style={{display:"flex", justifyContent:"center", alignItems: 'center'}}>
                                <center>
                                    {this.props.screenSize.width !== undefined && this.props.screenSize.width > 600 ?
                                        <div>
                                    <div style={{width:"auto", color:"white", fontSize:"120%", marginTop:"auto"}}>
                                        <FormattedMessage id="home.dates" defaultMessage="Dates" />
                                    </div>
                                            <DatePeriod getDate={this.handleSelectedDate} screenSize={this.props.screenSize} compact={true}/>
                                        </div>
                                        :
                                        <div>
                                            <DatePeriod getDate={this.handleSelectedDate} screenSize={this.props.screenSize} compact={true}/>
                                        </div>
                                    }
                                </center>
                            </div>
                        </div>
                    </Row>
                </Col>
            )
        }


        const renderAddPatientAndMenu = () => {
            return(
                 <Col >
                    {this.props.screenSize.width > 600 && this.accountInformation.readOnly !== true
                        ?
                        <>
                        <Tooltip style={{ zIndex: 99 }} id="tooltip-button-addpatient">
                            {this.select_tooltip("home.tooltip.addpatient")}
                        </Tooltip>
                        <button className="home-header-action" onClick={(e) => this.handleAddPatient(e, "patient")} style={{ backgroundColor: "#212529", borderRadius: "5px", border: "1px solid grey", marginRight:"1%"}} data-tooltip-id="tooltip-button-addpatient" data-tooltip-place="bottom">
                        {/*<button onClick={Utils.checkBit(this.subscription_info.features, Utils.featureToBitNumber("hepadom")) && this.accountInformation.role === "admin" ? this.handleAddPopup : (e) => this.handleAddPatient(e, "patient")} style={{ backgroundColor: "#212529", borderRadius: "5px", border: "1px solid grey", fontSize: "1.2em", marginRight:"1%"}}>*/}
                        <Icon name='user plus' size='large' inverted color='grey' style={{margin:"3px"}}/>
                    </button>
                        </>
                        :
                        null
                    }
                    <Tooltip style={{ zIndex: 99 }} id="tooltip-button-mainmenu">
                        {this.select_tooltip("home.tooltip.menu")}
                    </Tooltip>
                    <ButtonDropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                        <DropdownToggle className="home-header-action" no-caret="true" style={{ backgroundColor: "#212529", borderRadius: "5px" }} data-tooltip-id="tooltip-button-mainmenu" data-tooltip-place="bottom">
                            <span style={{ position: 'relative', display: 'inline-block' }}>
                                <Icon name='list' size='big' inverted color='grey'/>
                                {this.state.pendingInvitesCount > 0 && (
                                    <span style={{ position: 'absolute', top: 2, right: -2, width: 10, height: 10, background: '#dc3545', borderRadius: '50%', border: '2px solid #212529' }} />
                                )}
                            </span>
                        </DropdownToggle>
                        <DropdownMenu>
                            {this.props.screenSize.width > 600 || this.accountInformation.readOnly === true ?
                                null
                                :
                                <DropdownItem style={{ fontSize: "0.9em" }} onClick={this.handleAddPatient}>
                                    <FormattedMessage id="home.addpatient" defaultMessage="Add patient"/>
                                </DropdownItem>
                            }
                            <DropdownItem style={{ fontSize: "0.9em" }} onClick={this.handleAccount}>
                                <FormattedMessage id="home.account" defaultMessage="Account"/>
                            </DropdownItem>

                            { (false) ?
                            <DropdownItem style={{ fontSize: "0.9em" }} onClick={this.handleResearch}>
                                <FormattedMessage id="home.research" defaultMessage="Research"/>
                            </DropdownItem>
                            :
                            null
                            }
                            {((this.accountInformation.role === "admin")||(this.accountInformation.role === "staff"))? 
                                <div>
                                    <DropdownItem style={{ fontSize: "0.9em" }} onClick={this.handleStaffManagementMenu}>
                                        <FormattedMessage id="home.staff" defaultMessage="Staff"/>
                                    </DropdownItem>
                                </div>
                                :
                                null
                            }
                            {((this.accountInformation.role === "admin")||(this.accountInformation.role === "staff"))? 
                                <div>
                                    <DropdownItem style={{ fontSize: "0.9em" }} onClick={this.handleSensors}>
                                        <FormattedMessage id="home.sensor" defaultMessage="Device"/>
                                    </DropdownItem>
                                    <DropdownItem style={{ fontSize: "0.9em" }} onClick={this.handleGateways}>
                                        <FormattedMessage id="home.gateway" defaultMessage="Gateway"/>
                                    </DropdownItem>
                                    {Utils.checkBit(this.subscription_info.features, Utils.featureToBitNumber("configBleGateways")) && (
                                        <DropdownItem style={{ fontSize: "0.9em" }} onClick={this.handleWifiProvisioningMenu}>
                                            <FormattedMessage id="home.wifiProvisioning" defaultMessage="Provision Wi-Fi" />
                                        </DropdownItem>
                                    )}
                                </div>
                                :
                                null
                            }
                            {this.accountInformation.readOnly !== true && this.accountInformation.role !== "registered" ? 
                                <div>
                                    <DropdownItem style={{ fontSize: "0.9em" }} onClick={this.handleSentInvitationsMenu}>
                                        <FormattedMessage id="invitation.sent" defaultMessage="Sent invitations"/>
                                    </DropdownItem>  
                                </div>
                                :
                                null
                            }
                            {(this.accountInformation.role === "registered"
                              || this.accountInformation.role === "admin"
                              || this.accountInformation.role === "staff") ? 
                                <div>
                                    <DropdownItem style={{ fontSize: "0.9em" }} onClick={this.handleReceivedInvitationsMenu}>
                                        <FormattedMessage id="invitation.received" defaultMessage="Received invitations"/>
                                        {this.state.pendingInvitesCount > 0 && (
                                            <span style={{ marginLeft: 7, background: '#dc3545', color: 'white', borderRadius: 10, padding: '1px 6px', fontSize: '0.75em', fontWeight: 'bold', verticalAlign: 'middle' }}>
                                                {this.state.pendingInvitesCount}
                                            </span>
                                        )}
                                    </DropdownItem>  
                                </div>
                                :
                                null
                            }
                            {((this.accountInformation.role === "admin")||(this.accountInformation.role === "staff"))? 
                                <div>
                                    <DropdownItem style={{ fontSize: "0.9em" }} onClick={this.handleGroups}>
                                        <FormattedMessage id="group.designation" defaultMessage="Group"/>
                                    </DropdownItem>                                
                                </div>
                                :
                                null
                            }
                            <DropdownItem style={{ fontSize: "0.9em" }} onClick={this.handleDownloadExport}>
                                <FormattedMessage id="home.export" defaultMessage="Export"/>
                            </DropdownItem>                               
                            <DropdownItem style={{ fontSize: "0.9em" }} onClick={this.handleAbout}>
                                <FormattedMessage id="home.about" defaultMessage="About"/>
                            </DropdownItem>
                            <DropdownItem style={{ fontSize: "0.9em" }} onClick={this.disconnect}>
                                <FormattedMessage id="home.disconnect" defaultMessage="Disconnect"/>
                            </DropdownItem>                            
                            {this.props.screenSize.width > 600 ?
                                null
                                :
                                <ButtonDropdown isOpen={this.state.languagesDropdownOpen} toggle={this.languageToggle} style={{width:"100%", paddingLeft: "14px"}}>
                                    {this.getCurrentLanguageMenu()}
                                    <DropdownMenu>
                                        <DropdownItem style={{ fontSize: "0.9em" }} onClick={() => this.setCurrentLanguageMenu("en-GB")}>
                                            <Flag name='uk' />
                                            <FormattedMessage id="home.menu.language.english" defaultMessage="English"/>
                                        </DropdownItem>
                                        <DropdownItem style={{ fontSize: "0.9em" }} onClick={() => this.setCurrentLanguageMenu("fr-FR")}>
                                            <Flag name='france' />
                                            <FormattedMessage id="home.menu.language.french" defaultMessage="French"/>
                                        </DropdownItem>
                                        <DropdownItem style={{ fontSize: "0.9em" }} onClick={() => this.setCurrentLanguageMenu("es-ES")}>
                                            <Flag name='es' />
                                            <FormattedMessage id="home.menu.language.spanish" defaultMessage="Spanish"/>
                                        </DropdownItem>
                                    </DropdownMenu>
                                </ButtonDropdown>   
                            }
                        </DropdownMenu>
                    </ButtonDropdown>
                    {(this.accountInformation.role === "admin" && this.accountInformation.role_extra === "admin_etc" && !this.state.hideAdminMenu) &&
                        <ButtonDropdown isOpen={this.state.adminDropdownOpen} toggle={this.adminToggle} style={{ marginLeft: "4px" }}>
                            <DropdownToggle className="home-header-action" no-caret="true" style={{ backgroundColor: "#7b2d8b", borderRadius: "5px" }} title="Admin">
                                <Icon name='shield' size='big' inverted color='grey'/>
                            </DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem toggle={false} style={{ fontSize: "0.9em", display: "flex", alignItems: "center", gap: "6px", cursor: "pointer" }} onClick={this.toggleHidePatientIds}>
                                    <input type="checkbox" readOnly checked={this.state.hidePatientIds} style={{ cursor: "pointer" }} />
                                    <span><FormattedMessage id="admin.hidePatientIds" defaultMessage="Masquer les id_patient"/></span>
                                </DropdownItem>
                                <DropdownItem divider />
                                <DropdownItem style={{ fontSize: "0.9em" }} onClick={this.handleStructureManagementMenu}>
                                    <FormattedMessage id="structure.title" defaultMessage="Structures"/>
                                </DropdownItem>
                                <DropdownItem style={{ fontSize: "0.9em" }} onClick={this.handleSubscriptionManagementMenu}>
                                    <FormattedMessage id="subscription.title" defaultMessage="Abonnements"/>
                                </DropdownItem>
                                <DropdownItem style={{ fontSize: "0.9em" }} onClick={this.handleCertificateMenu}>
                                    <FormattedMessage id="home.certificate" defaultMessage="Certificate"/>
                                </DropdownItem>
                                {process.env.REACT_APP_DEBUG === 'true' &&
                                    <DropdownItem style={{ fontSize: "0.9em", color: "#c0392b" }} onClick={this.handleFixturesMenu}>
                                        <FormattedMessage id="admin.fixtures.title" defaultMessage="Fixtures"/>
                                    </DropdownItem>
                                }
                            </DropdownMenu>
                        </ButtonDropdown>
                    }
                </Col>
            )
        }

        const renderLanguageSelect = () => {
            // Mobile (<600px): no field in the header — the language switcher lives in the main menu
            if (this.props.screenSize.width !== undefined && this.props.screenSize.width <= 600) {
                return null;
            }
            // Tablet (600-1200px): half-size field showing the flag only
            const compactLang = this.props.screenSize.width !== undefined && this.props.screenSize.width < 1200;
            return(
                <div style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
                  <select
                    onChange={(e) => this.props.handleLocaleChange(this.accountInformation.username, e)}
                    value={this.props.currentLocale}
                    style={{
                      appearance: 'none',
                      WebkitAppearance: 'none',
                      MozAppearance: 'none',
                      background: 'rgba(255,255,255,0.1)',
                      color: '#fff',
                      border: '1px solid rgba(255,255,255,0.25)',
                      borderRadius: 8,
                      padding: compactLang ? '4px 16px 4px 6px' : '4px 28px 4px 8px',
                      fontSize: 13,
                      fontWeight: 500,
                      cursor: 'pointer',
                      outline: 'none',
                      minWidth: compactLang ? 60 : 120,
                    }}
                  >
                    {this.languages.map(({ name, code, flag }) => (
                      <option key={code} value={code} style={{ color: '#333', background: '#fff' }}>
                        {compactLang ? flag : `${flag}  ${name}`}
                      </option>
                    ))}
                  </select>
                  <span style={{ position: 'absolute', right: compactLang ? 4 : 8, pointerEvents: 'none', color: '#fff', fontSize: 11 }}>▾</span>
                </div>
            )
        }

   		return(
        	
            <div style={{height: "100%", width: "100%"}}>
                <Helmet>
                    <title>Tucky Center | Home</title>
                </Helmet>

                <nav className="navbar navbar-expand navbar-dark bg-dark" style={{height: "auto", minHeight: "50px", flex:1, flexDirection:'row', alignItems:'center', justifyContent:'center', paddingTop:"10px", paddingBottom:"10px"}}>
                    { renderNavBarLogo() }
                    { renderFilterViewAndDate() }
                    { renderAddPatientAndMenu() }
                    { renderLanguageSelect() }                    
                </nav>
                
                {(this.state.noStructureError) ?
                    <Card id="box-loading" style={{ textAlign: 'center', padding: '40px 20px' }}>
                        <Icon name='warning sign' size='big' color='orange' />
                        <br/><br/>
                        <FormattedMessage id="home.noStructure" defaultMessage="Your account is not linked to a structure. Please contact your administrator."/>
                    </Card>
                : (this.state.loadingState) ?
                    <PatientBoxList
                       profilesInformation      = {this.state.profilesInformation}
                       extendedView             = {this.state.switchExtendedView}
                       dateSelected             = {this.state.dateSelected}
                       updateProfileParameters  = {this.updateProfileParameters}
                       accountInformation       = {this.accountInformation}
                       structure_Id             = {this.accountInformation.FK_structure}
                       subscription_info        = {this.subscription_info}
                       struct_info              = {this.structure_info}
                       userRole                 = {this.accountInformation.role}
                       reloadUserAndProfiles    = {this.reloadUserAndProfiles}
                       structure_groups         = {this.state.structure_groups}
                       structure_devices        = {this.state.structure_devices}
                       structure_gateways        = {this.state.structure_gateways}
                       select_tooltip           = {this.select_tooltip}
                       screenSize               = {this.props.screenSize}
                       intl                     = {this.props.intl}
                       hidePatientIds           = {this.state.hidePatientIds}
                    />
                    :
                    <Card id="box-loading">
                        <FormattedMessage id="home.loading" defaultMessage="Loading in progress, please wait..."/>
                        <br/><br/>               
                        <Icon loading name='spinner' size='big'/>
                    </Card>
                }
                {(this.state.popup === "account")                ? <Account                    cancelPopup={this.cancelPopup} accountInformation={this.accountInformation} struct_info={this.structure_info} subscription_info={this.subscription_info} keycloak={keycloak} currentLocale={this.props.currentLocale} hideAdminMenu={this.state.hideAdminMenu} toggleHideAdminMenu={this.toggleHideAdminMenu}/> : null}
                {(this.state.popup === "research")               ? <Research                   cancelPopup={this.cancelPopup} accountInformation={this.accountInformation} struct_info={this.structure_info} subscription_info={this.subscription_info} handleFilterChange={this.handleFilterChange} resetFilter={this.resetFilter} previous_filter={this.state.previous_filter}/> : null}
                {(this.state.popup === "receivedInvitations")    ? <ReceivedInvitationsMenu    cancelPopup={this.cancelPopup} structure_Id={this.accountInformation.FK_structure} userEmail={this.accountInformation.email} profilesInformation={this.state.profilesInformation} accountMailAddress={this.accountInformation.email} reloadUserAndProfiles={this.reloadUserAndProfiles}/> : null}
                {(this.state.popup === "sentInvitations")        ? <SentInvitationsMenu        cancelPopup={this.cancelPopup} structure_Id={this.accountInformation.FK_structure} userEmail={this.accountInformation.email} reloadUserAndProfiles={this.reloadUserAndProfiles}/> : null}
                {(this.state.popup === "sensors")                ? <Sensors                    cancelPopup={this.cancelPopup} accountInformation={this.accountInformation} profilesInformation={this.state.profilesInformation} structure_Id={this.accountInformation.FK_structure} struct_info={this.structure_info} subscription_info={this.subscription_info} reloadUserAndProfiles={this.reloadUserAndProfiles} device_list={this.state.structure_devices} setDeviceList={this.setDeviceList}/> : null}
                {(this.state.popup === "gateways")               ? <GatewayManagementMenu      cancelPopup={this.cancelPopup} accountInformation={this.accountInformation} role={this.accountInformation.role} structure_Id={this.accountInformation.FK_structure} struct_info={this.structure_info} subscription_info={this.subscription_info} reloadUserAndProfiles={this.reloadUserAndProfiles} gateway_list={this.state.structure_gateways} setGatewayList={this.setGatewayList}/> : null}
                {(this.state.popup === "wifiProvisioning") ? <WifiProvisioningMenu cancelPopup={this.cancelPopup} /> : null}
                {(this.state.popup === "about")                  ? <About                      cancelPopup={this.cancelPopup} /> : null}
                {(this.state.popup === "staff")                  ? <StaffManagementMenu        cancelPopup={this.cancelPopup} accountInformation={this.accountInformation} structure_Id={this.accountInformation.FK_structure} struct_info={this.structure_info} subscription_info={this.subscription_info} staff_list={this.state.staff_list} load_staff={this.load_staff}/> : null}
                {(this.state.popup === "structure")              ? <StructureManagementMenu    cancelPopup={this.cancelPopup} accountInformation={this.accountInformation} initialSubscriptionFilter={this.state.popupParams.subscriptionFilter || null} onOpenSubscription={this.handleOpenSubscriptionFromStructure}/> : null}
                {(this.state.popup === "subscription")           ? <SubscriptionManagementMenu cancelPopup={this.cancelPopup} accountInformation={this.accountInformation} highlightId={this.state.popupParams.highlightId || null} onOpenStructures={this.handleOpenStructuresForSubscription}/> : null}
                {(this.state.popup === "certificate")            ? <CertificateInfoPopup       cancelPopup={this.cancelPopup}/> : null}
                {(this.state.popup === "fixturesMenu")           ? <FixturesMenu               cancelPopup={this.cancelPopup} accountInformation={this.accountInformation}/> : null}
                {(this.state.popup === "addpatient")             ? <AddPatient                 cancelPopup={this.cancelPopup} closeAfterAdd={this.closeAfterAddingNewPatient} role={this.accountInformation.role} groups={this.state.structure_groups} selected_filter={this.props.currentFilter} structure_Id={this.accountInformation.FK_structure} struct_info={this.structure_info} subscription_info={this.subscription_info} accountInformation={this.accountInformation} reloadUserAndProfiles={this.reloadUserAndProfiles} template_list={this.state.template_list} setRequestPulling={this.set_request_pulling}/> : null}
                {(this.state.popup === "groups")                 ? <GroupManagementMenu        cancelPopup={this.cancelPopup} accountInformation={this.accountInformation} closeAfterAdd={this.closeAfterAddingNewPatient} role={this.accountInformation.role} structure_Id={this.accountInformation.FK_structure} reloadGroups={this.load_groups} struct_info={this.structure_info} subscription_info={this.subscription_info}/> : null}
            </div>
   		);
   	}
}
export default injectIntl(Home);